
require('./src/styles/global.css')

exports.onClientEntry = () => {}
